const MuiTableCell = {
	body: {
		fontSize: '1em'
	}
};

export default MuiTableCell;
